import React, { useContext, useEffect, useState } from 'react'
import { AppSettings } from '../../config/app-settings'
import Loader from '../pages/loader'
import { can } from '../../helpers/auth'
import ReusableTable from '../../components/other/ReuseableTable'
import { toast } from 'react-toastify'
import AddCustomerCampaignModal from '../../components/campaigns/loa/AddCustomerCampaignModal'
import { useGetLoaQuery, useLazyGetLoaQuery } from '../../redux/apis/campaignsManagement/loa/cMLoaApiSlice'
import SearchAndFilterBar from '../../components/other/search/SearchAndFilterBar'
import DownloadAllDataButton from '../../components/other/DownloadAllDataButton'
import CustomersDropdown from '../../components/CustomersDropdown'
import CampaignDropdown from '../../components/CampaignDropdown'

const CampaignsLoa = React.memo(() => {
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10
  })
  const [search, setSearch] = useState('')
  const [filters, setFilters] = useState({})

  const context = useContext(AppSettings)
  const transformedFilters = Object.entries(filters).reduce(
    (acc, [key, value]) => {
      if (key === 'customer_name') {
        acc['customer'] = value
      } else if (key === 'campaign_name') {
        acc['campaign'] = value
      } else {
        acc[key] = value
      }
      return acc
    },
    {}
  )

  const { data, isLoading, error, isFetching } = useGetLoaQuery({
    expand: ['last_updated_by', 'customer'].join(','),
    page: pagination.current,
    page_size: pagination.pageSize,
    ...(search ? { search } : {}),
    ...transformedFilters
  })

  let columns = [
    {
      title: 'Campaign ID',
      dataIndex: 'campaign_id',
      key: 'campaign_id',
    },
    {
      title: 'Customer Name',
      dataIndex: 'customer_name',
      key: 'customer_name',
      filter: true,
      filterType: 'text',
      filterComponent: CustomersDropdown
    },
    {
      title: 'Campaign Name',
      dataIndex: 'campaign_name',
      key: 'campaign_name',
      filter: true,
      filterType: 'text',
      filterComponent: CampaignDropdown,
      related: 'customer_name',
      relatedProp: 'customer_id',
      relatedDependence: true
    },
    {
      title: 'Campaign LOA Dropbox URL',
      dataIndex: 'campaign_loa_dropbox_url',
      key: 'campaign_loa_dropbox_url',

    }
  ]

  const handleTableChange = paginationInfo => {
    setPagination({
      current: paginationInfo.current,
      pageSize: paginationInfo.pageSize
    })
  }

  useEffect(() => {
    if (error?.data) {
      const errorMessages = Object.values(error.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    }
  }, [error])

  useEffect(() => {
    context.setAppHeaderNone(false)
    context.setAppSidebarNone(false)
    context.setAppContentClass('')
    context.setAppThemePanal(true)

    return () => {
      context.setAppHeaderNone(true)
      context.setAppSidebarNone(true)
      context.setAppContentClass('p-0')
      context.setAppThemePanal(false)
    }
  }, [context])

  return (
    <div className='w-full flex flex-col'>
      <Loader isLoading={isLoading || isFetching} />

      <div className='flex'>
        <SearchAndFilterBar
          columns={columns}
          search={search}
          setSearch={setSearch}
          filters={filters}
          setFilters={setFilters}
          setPagination={setPagination}
        />
        <div className='ml-auto flex gap-4'>
          <DownloadAllDataButton
            lazyQueryHook={useLazyGetLoaQuery}
            fileName='campaignsloa'
          />
          {can('add_campaign_loa') && <AddCustomerCampaignModal />}
        </div>
      </div>

      <div className='row'>
        <ReusableTable
          columns={columns}
          data={data?.data?.results}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: data?.data?.count,
            showSizeChanger: true
          }}
          onChange={handleTableChange}
        />
      </div>
    </div>
  )
})

export default CampaignsLoa
